<template>
  <ul v-bind:class="{ 'nav nav-pills nav-stacked': !issub, 'nav-sub': issub }">
    <slot name="item" v-for="item in items">
      <!-- ACTIONS -->
      <li v-if="item.actions && visEval(item.visible)"
          :class="item.styleClasses">
        <a href="#" :title="item.label" v-on:click.prevent="action(item.actions)">
          <i :class="item.icon"></i> {{ item.label }}
        </a>
      </li>

      <!-- REGULAR NAVITEM -->
      <router-link
        v-else-if="item.path && visEval(item.visible)"
        tag="li"
        :to="item.path"
        :exact="item.exact"
        :title="item.label"
        active-class="active"
        :class="[item.styleClasses, { 'active': isActive(item) }]"
        v-on:click.native="closeNavbar()">
        <a><i :class="item.icon"></i> {{ item.label }}</a>
      </router-link>

      <!-- SUBMENU LABEL -->
      <li v-if="item.subs && visEval(item.visible)"
          class="nav-dropdown"
          :class="[item.styleClasses, { 'open': isDropdownOpen(item), 'active': isSubItemActive(item) }]">
        <a href="#" :title="item.label" v-on:click="toggleDropdown(item)">
          <i :class="item.icon"></i> {{ item.label }}
        </a>
      
        <!-- SUB MENU -->
        <nav-bar-item
          v-if="isDropdownOpen(item) || isSubItemActive(item)"
          :key="item.label"
          :class="[item.styleClasses, { 'active': isSubItemActive(item) || isDropdownOpen(item) }]"
          :items="item.subs"
          :issub="true"
          v-bind:style="{ 'display': ((!isDropdownOpen(item) && issub) && !isSubItemActive(item)) ? 'none' : 'block' }"
          @input="toggleDropdown(item)">
          <template slot="item" slot-scope="props"></template>
        </nav-bar-item>      
      </li>

      <!-- HTML -->
      <li v-show="item.html && visEval(item.visible)"
          :class="item.styleClasses">
        <html-renderer-old
          :template="item.html"
          :app="$store.state.site.content.app">
        </html-renderer-old>
      </li>
    </slot>
  </ul>
</template>

<script>
import { EventBus } from "Js/eventBus";

export default {
  name: "nav-bar-item",

  methods: {
    action(actionsOrNamed) {
      this.closeNavbar();
      if (actionsOrNamed.name) {
        EventBus.$emit("processNamedAction", actionsOrNamed);
      } else {
        let actionsArray = actionsOrNamed.constructor === Array ? actionsOrNamed : [actionsOrNamed];
        EventBus.$emit("processActions", actionsArray);
      }
    },

    visEval(func) {
      return typeof func === "function" ? func() : func != null ? func : 1;
    },

    closeNavbar() {
      this.$store.commit("SET_SIDEBAROPEN", !this.$store.state.site.sidebarOpen);
    },
    
    toggleDropdown(item) {
      this.$set(this.dropdownOpen, item.label, !this.dropdownOpen[item.label]);
    },

    isDropdownOpen(item) {
      return this.dropdownOpen[item.label];
    },

    isActive(item) {
      return this.$route.path === item.path;
    },

    isSubItemActive(item) {
      if (!item.subs) return false;
      return item.subs.some(subItem => {
        if (subItem.path === this.$route.path) return true;
        if (subItem.subs) return this.isSubItemActive(subItem);
        return false;
      });
    }
  },

  props: {
    items: Array,
    issub: Boolean
  },

  data() {
    return {
      dropdownOpen: {}
    };
  },

  watch: {
    $route() {
      this.items.forEach(item => {
        if (this.isSubItemActive(item)) {
          this.$set(this.dropdownOpen, item.label, true);
        } else {
          this.$set(this.dropdownOpen, item.label, false);
        }
      });
    }
  }
};
</script>

<style></style>